import Vue from "vue";
import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

// Note that all potential fields should be included, so they will be reactive
function GetEmptyCustomer() {
  return {
    Current_Ski_Brand: undefined,
    Current_Ski_Age: undefined,
    First_Name: "",
    Last_Name: "",
    Email: undefined,
    Mobile: undefined,
    Street: undefined,
    City: undefined,
    State: undefined,
    Zip_Code: undefined,
    Country: "USA",

    Has_Guardian: false,

    Guardian_First_Name: undefined,
    Guardian_Last_Name: undefined,

    Copy_Guardian: false,

    Guardian_Email: undefined,
    Guardian_Phone: undefined,
    Guardian_Street: undefined,
    Guardian_City: undefined,
    Guardian_State: undefined,
    Guardian_Zip_Code: undefined,
    Guardian_Country: "USA",

    Type_of_Skier: undefined,
    Height: undefined,
    Weight: undefined,
    Age: undefined,
    Boot_Make: undefined,
    Sole: undefined,

    Participant_Tag: undefined,

    Indicator_Setting: undefined,

    Agree: false,
  };
}

export default new Vuex.Store({
  state: {
    apitoken: undefined,
    apiexpiration: undefined,
    email: undefined,
    role: undefined,
    location: undefined,

    // Calculator inter-page values
    skierInfo: GetEmptyCustomer(),
    savedIndicator: undefined,
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    SetToken(state, token) {
      state.apitoken = token;
    },
    SetExpiration(state, seconds) {
      if (seconds) {
        // Set expiration date, minus 12 hours for safety
        state.apiexpiration = Date.now() + (seconds - 43200) * 1000;
      } else {
        state.apiexpiration = undefined;
      }
    },
    SetEmail(state, email) {
      state.email = email;
    },
    SetRole(state, role) {
      state.role = role;
    },
    SetLocation(state, location) {
      state.location = location;
    },
    SetSavedIndicator(state, savedIndicator) {
      state.savedIndicator = savedIndicator;
    },
    ClearSkierInfo(state) {
      state.skierInfo = GetEmptyCustomer();
    },
  },
  actions: {
    async Logout({ commit }) {
      commit("SetToken", undefined);
      commit("SetExpiration", undefined);
      commit("SetEmail", undefined);
      commit("SetRole", undefined);
      commit("SetLocation", undefined);
      commit("ClearSkierInfo");
      location.reload();
    },
  },
  modules: {
  },
  plugins: [
    createPersistedState(),
  ],
  strict: process.env.NODE_ENV !== "production",
});
